<div class="dialog-pqr">
  <div class="header">
    <h2 mat-dialog-title>Atenção!</h2>

    <mat-dialog-actions>
      <button mat-dialog-close class="close-button">×</button>
    </mat-dialog-actions>
  </div>

  <mat-dialog-content>
    Ao restaurar os valores com base no PQR
    <strong>tudo que já foi informado será perdido.</strong> Deseja continuar?
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <button class="yes-button" [mat-dialog-close]="true">Sim</button>
    <button class="no-button" [mat-dialog-close]="false">Não</button>
  </mat-dialog-actions>
</div>
